var map = {
	"./android-chrome-192x192.png": "./src/img/android-chrome-192x192.png",
	"./android-chrome-512x512.png": "./src/img/android-chrome-512x512.png",
	"./apple-touch-icon.png": "./src/img/apple-touch-icon.png",
	"./brut/brut-bg.jpg": "./src/img/brut/brut-bg.jpg",
	"./brut/brut-dashicon.png": "./src/img/brut/brut-dashicon.png",
	"./brut/brut-icon.png": "./src/img/brut/brut-icon.png",
	"./brut/brut-logo-white.png": "./src/img/brut/brut-logo-white.png",
	"./brut/brut-logo.png": "./src/img/brut/brut-logo.png",
	"./favicon-16x16.png": "./src/img/favicon-16x16.png",
	"./favicon-32x32.png": "./src/img/favicon-32x32.png",
	"./favicon.ico": "./src/img/favicon.ico",
	"./logo.webp": "./src/img/logo.webp",
	"./payoff.webp": "./src/img/payoff.webp",
	"./site.webmanifest": "./src/img/site.webmanifest",
	"./swoosh.png": "./src/img/swoosh.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img sync recursive ^\\.\\/.*$";